const loadRoomRate = ({ check_in, check_out, hotel_id, rooms, adults, children }) => {
  const url = `${process.env.API_URL}/hotel/search/detail/?check_in=${check_in}&check_out=${check_out}&hotel_id=${hotel_id}&rooms=${rooms}&adults=${adults}&children=${children}`;
  return fetch(url, { credentials: 'include' });
};

export default loadRoomRate;
